<template>
  <div class="msg-area">
    <!-- Welcome message -->
    <msg-block>
      <p>
        <b>{{ translations.welcome_msg_title }} {{ agencyName }}</b>
      </p>
      <p v-html="translations.welcome_msg"></p>
    </msg-block>

    <!-- Offer notice message -->
    <msg-block type="warning">
      <p v-html="translations.offer_notice"></p>
    </msg-block>

    <!-- Loding message -->
    <msg-block v-if="loadingOffer" class="item-loading">
      <p><b v-text="translations.loading_offer"></b></p>
    </msg-block>

    <!-- Loading error -->
    <msg-block v-if="loadingError" type="error">
      <p><b v-text="loadingError"></b></p>
    </msg-block>

    <!-- NK Offer -->
    <modal
      v-if="isNKOffer"
      :title="translations.NK_notice_title"
      :isOpen="true"
      :noScroll="true"
      @close="goBackToSearch"
      class="modal-view--bg modal--booking"
    >
      <svg
        slot="icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 435.2 405.04"
      >
        <path
          d="M115.14,0H319.9c63.34,0,115.3,50.72,115.3,112.83v94.09C435.2,269,383.24,320,319.9,320H259.11l-97.75,81.47c-4.23,3.77-19.92,4.6-25.09,2.28A13.83,13.83,0,0,1,128,390.87V320H115.14C51.79,320,0,269,0,206.92V112.83C0,50.72,51.79,0,115.14,0Z"
        />
      </svg>
      <p v-html="translations.NK_notice"></p>
      <div class="modal-actions">
        <a
          class="btn"
          href="javascript:void(0)"
          @click="goBackToSearch"
          v-text="translations.ERRORS.no_offer_back"
        ></a>
      </div>
    </modal>

    <!-- Warning if RQ travel -->
    <msg-block type="warning" v-if="isRQTravel">
      <p><b v-text="translations.RQ_notice"></b></p>
    </msg-block>

    <!-- Booking error -->
    <msg-block type="error" v-if="bookingError">
      <p><b v-html="bookingError"></b></p>
    </msg-block>

    <!-- Booking state info -->
    <msg-block v-if="bookingState" class="item-loading">
      <p><b v-html="bookingState"></b></p>
    </msg-block>

    <!-- Admin warning -->
    <msg-block v-if="adminWarning" type="warning">
      <p
        v-for="(txt, txtKey) in translations.ERRORS.booking_warning"
        v-html="txt"
        :key="'adminwarning_' + txtKey"
      ></p>
      <a href="/" v-text="translations.back_btn_frontpage"></a>
    </msg-block>

    <!-- Changelist error list -->
    <modal
      v-if="showChangesModal"
      :title="translations.ERRORS.change_notice_title"
      :isOpen="true"
      @close="closeChangesModal"
      :closeOnClick="true"
      class="modal-view--bg modal--booking"
    >
      <svg
        slot="icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 435.2 405.04"
      >
        <path
          d="M115.14,0H319.9c63.34,0,115.3,50.72,115.3,112.83v94.09C435.2,269,383.24,320,319.9,320H259.11l-97.75,81.47c-4.23,3.77-19.92,4.6-25.09,2.28A13.83,13.83,0,0,1,128,390.87V320H115.14C51.79,320,0,269,0,206.92V112.83C0,50.72,51.79,0,115.14,0Z"
        />
      </svg>
      <div v-if="changeList.length > 0">
        <p v-text="translations.ERRORS.change_notice_txt"></p>
        <ul>
          <li
            v-for="(changedTxt, changedKey) in filteredChangeList"
            v-html="changedTxt"
            :key="changedKey"
          ></li>
        </ul>
        <div class="modal-actions">
          <button
            class="btn"
            @click="closeChangesModal"
            v-text="translations.ERRORS.change_notice_btn"
          ></button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import MsgBlock from "./../msg-block.vue";
import Modal from "./../modal.vue";
import _ from "underscore";

let NoticeTimer = null;

export default {
  props: {
    loadingOffer: { type: Boolean, default: false },
    loadingError: { type: Boolean|String, default: false },
    isNKOffer: { type: Boolean, default: false },
    bookingError: { type: String, default: null },
    bookingState: { type: String, default: null },
    adminWarning: { type: Boolean, default: false },
    inEditMode: { type: Boolean, default: false },
    changeList: {
      type: Object | Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      translations: APP_CONFIG.TRANSLATION.BOOKING_MESSAGES,
      showChangesModal: false,
    };
  },
  watch: {
    changeList(newList, oldList) {
      if (!_.isEqual(newList, oldList)) {
        if (this.inEditMode) {
          this.showMsgBarIfChanges();
        } else {
          this.openChangesModal();
        }
      }
    },
  },
  mounted() {
    if (this.changeList.length) {
      this.showMsgBarIfChanges();
    } else {
      this.startNoticeTimer();
    }

    this.$nextTick(() => {
      if (typeof window.MAIN_APP !== "undefined") {
        window.MAIN_APP.$on("msgclick", this.openChangesModal);
      }
    });
  },
  beforeDestroy() {
    this.stopNoticeTimer();
    this.hideMsgBar();
    if (typeof window.MAIN_APP !== "undefined") {
      window.MAIN_APP.$off("msgclick", this.openChangesModal);
    }
  },
  methods: {
    startNoticeTimer() {
      if (!NoticeTimer) {
        NoticeTimer = setTimeout(() => {
          this.showMsgBarTimeNotice();
        }, 720000); //12 minutes
      }
    },
    stopNoticeTimer() {
      if (NoticeTimer) {
        clearTimeout(NoticeTimer);
        NoticeTimer = null;
      }
    },
    goBackToSearch() {
      if (this.hasNavigated) {
        this.$emit("goback");
      } else {
        window.location = "/";
      }
    },
    showMsgBarIfChanges() {
      if (typeof window.MAIN_APP !== "undefined") {
        this.stopNoticeTimer();
        window.MAIN_APP.$emit("showmsg", {
          messages: this.translations.ERRORS.change_notice_msg,
          type: "warning",
        });
      }
    },
    showMsgBarTimeNotice() {
      if (typeof window.MAIN_APP !== "undefined" && !this.changeList.length) {
        window.MAIN_APP.$emit("showmsg", {
          messages: this.translations.offer_notice,
          type: "warning",
        });
      }
    },
    hideMsgBar() {
      if (typeof window.MAIN_APP !== "undefined") {
        window.MAIN_APP.$emit("closemsg");
      }
    },
    openChangesModal() {
      if (this.changeList.length > 0) {
        this.hideMsgBar();
        this.showChangesModal = true;
      }
    },
    closeChangesModal() {
      this.showChangesModal = false;
    },
  },
  computed: {
    isRQTravel() {
      return this.$store.state.selectedBookingOffer &&
        this.$store.state.selectedBookingOffer.verifiedOffer &&
        this.$store.state.selectedBookingOffer.verifiedOffer.status === "RQ"
        ? true
        : false;
    },
    hasNavigated() {
      return this.$store.getters.hasNavigated;
    },
    tourOperatorInfo() {
      return _.propertyOf(this.$store.state.selectedBookingOffer)([
        "verifiedOffer",
        "packageOffer",
        "tourOperator",
      ]);
    },
    agencyName() {
      return this.tourOperatorInfo && this.tourOperatorInfo.name ? this.tourOperatorInfo.name : '';
    },
    filteredChangeList() {
      let departureChanges = this.changeList.filter(({type}) => ['departureDate', 'outboundStops'].indexOf(type) > -1);
      let inboundChanges = this.changeList.filter(({type}) => ['inboundStops', 'homeAgainDate'].indexOf(type) > -1);

      return this.changeList.filter(({type}) => {
        if(departureChanges.length && type == 'outboundFlight') {
          return false;
        }

        if(inboundChanges.length && type == 'inboundFlight') {
          return false;
        }

        return true;
      }).map(({text}) => text);
    }
  },
  components: {
    MsgBlock,
    Modal,
  },
};
</script>